module.exports = __webpack_public_path__ + "img/violet_122.c778483f.png";